import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { AdmRedePostosServices } from '../adm-rede-postos.service';
import { AdmRedePosto, PerfisMasterInterface } from '../macro-posto.interface';

@Component({
  selector: 'app-editar-usuario-master',
  templateUrl: './editar-usuario-master.component.html',
  styleUrls: ['./editar-usuario-master.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatSpinnerOverlayComponent,
  ],
})
export class EditarUsuarioMasterComponent implements OnInit {
  public loading: boolean = false;
  public dialogRef = inject(MatDialogRef<EditarUsuarioMasterComponent>);
  private service = inject(AdmRedePostosServices);
  private snack = inject(SnackBarService);

  public isUnchanged = true;
  private originalUserValue: any;
  listaPerfis!: PerfisMasterInterface[];
  admRedePosto: AdmRedePosto = this.data.admRedePosto;

  get perfis(): PerfisMasterInterface[] {
    return this.listaPerfis;
  }

  usuarioForm: FormGroup = new FormGroup({
    codLogin: new FormControl('', [Validators.required]),
    dscLogin: new FormControl('', [Validators.required]),
    dscNome: new FormControl('', [Validators.required]),
    dscEmail: new FormControl('', [Validators.required, Validators.email]),
    datExpedicaoRg: new FormControl('', []),
    numDddFone: new FormControl('', [
      Validators.pattern('^[0-9]{2}$'),
      Validators.minLength(2),
      Validators.maxLength(2),
    ]),
    numFone: new FormControl('', [
      Validators.pattern('^[0-9]{9}$'),
      Validators.minLength(9),
      Validators.maxLength(9),
    ]),
    codPerfil: new FormControl('', [Validators.required]),
    descPerfil: new FormControl('', [Validators.required]),
    indAtivo: new FormControl(false, [Validators.required]),
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    //this.listaPerfis = this.data.perfis || [];
    this.admRedePosto = this.data.admRedePosto;

    if (this.data.usuario) {
      this.originalUserValue = this.usuarioForm.getRawValue();
      console.log(this.data.usuario);

      this.usuarioForm.patchValue({
        codLogin: String(this.data.usuario.codLogin || ''),
        dscLogin: this.data.usuario.dscLogin,
        dscNome: this.data.usuario.dscNome,
        dscEmail: this.data.usuario.dscEmail,
        datExpedicaoRg: new Date(this.data.usuario.datExpedicaoRg)
          .toISOString()
          .substring(0, 10),
        numDddFone: this.data.usuario.numDddFone,
        numFone: this.data.usuario.numFone?.replace('-', ''),
        codPerfil: this.data.usuario.codPerfil,
        descPerfil: this.data.usuario.descPerfil,
        indAtivo: this.data.usuario.indAtivo,
      });

      this.usuarioForm.valueChanges.subscribe(() => {
        this.checkIfUnchanged();
      });
    }
  }
  private checkIfUnchanged(): void {
    this.isUnchanged =
      JSON.stringify(this.originalUserValue) ===
      JSON.stringify(this.usuarioForm.getRawValue());
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  formatDate(dateStr: string): string {
    const [year, month, day] = dateStr.split('-');
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  onConfirmar(): void {
    this.loading = true;
    const result = this.usuarioForm.value;
    const usuarioEditado: any = {
      codLogin: parseInt(result.codLogin || '0', 10),
      Codentidade: this.admRedePosto.codEntidade,
      DscLoginEntidade: this.admRedePosto.dscLoginEntidade,
      dscNome: result.dscNome || '',
      dscLogin: result.dscLogin || '',
      dscIdentificacao: result.dscLogin || '',
      dscEmail: result.dscEmail || '',
      numDddFone: result.numDddFone || '',
      numFone: result.numFone || '',
      datExpedicaoRg: this.formatDate(result.datExpedicaoRg || ''),
      codPerfil: result.codPerfil.toString(),
      indAtivo: result.indAtivo ? 1 : 0,
    };
    console.log(usuarioEditado);

    this.service.atualizarUsuarioMaster(usuarioEditado).subscribe({
      next: (res) => {
        console.log(res);
        if (res && res.sucesso) {
          this.dialogRef.close(res);
        } else {
          throw new Error('Falha ao atualizar usuário');
        }
      },
      error: (err) => {
        this.snack.flashMessage(
          err?.mensagens[0] || 'Erro ao atualizar usuário',
          ['snackbar-error'],
          'Fechar',
          3000
        );
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
